import { render, staticRenderFns } from "./productListGrid.vue?vue&type=template&id=5324e7ac&"
import script from "./productListGrid.vue?vue&type=script&lang=js&"
export * from "./productListGrid.vue?vue&type=script&lang=js&"
import style0 from "./productListGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports